import {
  setApiOptions,
  enableJwtAuth,
  setLoggingOptions,
  enableSentryLogger,
  enableSegmentLogger,
  enableHotjarLogger,
  setPreferenceDefaults,
  setResponsiveOptions,
  createDefaultReduxStore,
} from "@redriver/cinnamon";
import reducers from "./reducers";
import { onRefreshJwt, onDeauthenticated } from "features/System";
import { ScreenBreakpoints } from "constants/breakpoints";

export const setupApp = () => {
  configureApi();
  configureAuth();
  configureLogging();
  configurePreferences();
  configureResponsive();
  const store = configureStore();
  return { store };
};

// api / auth modules

const configureApi = () =>
  setApiOptions({
    apiUrl: process.env.API_URL,
  });

const configureAuth = () =>
  enableJwtAuth({
    tokenKey: `${process.env.COOKIE_PREFIX}-token-key`,
    jwtClaims: {
      emailVerified: {
        type: "boolean",
        key: "ev",
      },
      userId: {
        type: "string",
        key: "sub",
      },
      userName: {
        type: "join",
        keys: ["fn", "ln"],
        separator: " ",
      },
      userEmail: {
        type: "string",
        key: "e",
        identity: "email",
      },
      permissions: {
        type: "object",
        keys: "^p_(.+)",
      },
    },
    onRefreshJwt,
    onDeauthenticated,
  });

// logging module

const configureLogging = () => {
  setLoggingOptions({
    environment: process.env.LOGGING_ENVIRONMENT,
    release: process.env.LOGGING_RELEASE,
  });
  if (process.env.SENTRY_DSN) {
    enableSentryLogger(process.env.SENTRY_DSN);
  }
  if (process.env.SEGMENT_APIKEY) {
    enableSegmentLogger(process.env.SEGMENT_APIKEY);
  }
  if (process.env.HOTJAR_SITEID) {
    enableHotjarLogger(process.env.HOTJAR_SITEID);
  }
};

// preferences module

const configurePreferences = () =>
  setPreferenceDefaults({
    timezone: "Europe/London",
  });

// responsive module

const configureResponsive = () =>
  setResponsiveOptions({
    screenSizes: {
      small: { max: ScreenBreakpoints.SmallMax },
      medium: {
        min: ScreenBreakpoints.MediumMin,
        max: ScreenBreakpoints.MediumMax,
      },
      large: { min: ScreenBreakpoints.LargeMin },
    },
  });

// redux store module

const configureStore = () =>
  createDefaultReduxStore({
    reducers,
    reduxDevTools: process.env.REDUX_DEVTOOLS,
  });
